/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { validatePackage as m } from "@progress/kendo-licensing";
import { canUseDOM as a } from "./canUseDOM.mjs";
const i = ["telerik.com", "progress.com", "stackblitz.io", "csb.app"], p = "https://www.telerik.com/kendo-react-ui/components/free?utm_medium=product&utm_source=console&utm_campaign=dt_kendoreact_freemium", o = /* @__PURE__ */ new Map(), u = () => {
  const c = Array.from(o, ([e, t]) => `- ${e}: ${Array.from(t).join(", ") || "all"}`).join(`
`);
  console.group("[WARN][Telerik and Kendo UI Licensing] KendoReact"), console.warn(
    `License check was triggered by these premium KendoReact components/features
${c}
See the full list of free and premium components here: ${p}`
  ), console.groupEnd(), o.clear();
}, h = (c, e) => {
  const t = m(c), r = i.some(
    (s) => {
      var n;
      return (n = globalThis.document) == null ? void 0 : n.location.hostname.endsWith(s);
    }
  );
  if (!t && a && e)
    if (o.size === 0 && setTimeout(u, 1e3), o.has(e.component)) {
      const s = o.get(e.component) || [];
      o.set(e.component, /* @__PURE__ */ new Set([...e.features || [], ...s]));
    } else
      o.set(e.component, e.features || []);
  return t || r;
};
export {
  h as validatePackage
};
